exports.init = (() => {
  setTimeout(() => {
    const hasContent = (e) => {
      const target = e.target;
      if (['select'].indexOf(target.nodeName.toLowerCase()) >= 0) {
        if (target.value > 0 && target.value.length) {
          target.closest('label').classList.add('has-content');
        } else {
          target.closest('label').classList.remove('has-content');
        }
      } else if (target.value && target.value.length) {
        target.closest('label').classList.add('has-content');
      } else {
        target.closest('label').classList.remove('has-content');
      }
    };

    const triggerEvent = (el, type) => {
      let ev;
      if ('createEvent' in document) {
        // modern browsers, IE9+
        ev = document.createEvent('HTMLEvents');
        ev.initEvent(type, false, true);
        el.dispatchEvent(ev);
      } else {
        // IE 8
        ev = document.createEventObject();
        ev.eventType = type;
        el.fireEvent(`on${ev.eventType}`, ev);
      }
    };

    const onFocusInEventHandler = (event) => {
      const parent = event.currentTarget.closest('label');
      const activeClass = 'is-active';

      if (!parent.classList.contains(activeClass)) {
        parent.classList.add(activeClass);
      }
    };

    const onFocusOutEventHandler = (event) => {
      const parent = event.currentTarget.closest('label');
      const activeClass = 'is-active';

      if (parent.classList.contains(activeClass)) {
        parent.classList.remove(activeClass);
      }
    };

    const inputs = document.querySelectorAll('[role="input"] input, [role="text"] input, [role="password"] input, [role="email"] input, [role="number"] input, [role="url"] input, [role="tel"] input, [role="time"] input, [role="date"] input, [role="datetime"] input, [role="month"] input, [role="week"] input, [role="search"] input, [role="range"] input, [role="select"] select, textarea');
    if (inputs && inputs.length) {
      inputs.forEach((input) => {
        input.addEventListener('change', hasContent, false);
        input.addEventListener('keyup', hasContent, false);
        input.addEventListener('blur', hasContent, false);
        input.addEventListener('focusin', onFocusInEventHandler);
        input.addEventListener('focusout', onFocusOutEventHandler);
        triggerEvent(input, 'change');
      });
    }

    const textareaAutosize = (e) => {
      const target = e.target;
      const mirrow = target.closest('.text-container').querySelector('textarea.mirrow');
      mirrow.value = target.value;
      window.requestAnimationFrame(() => {
        // target.style.cssText = 'height:auto;';
        target.style.height = `${mirrow.scrollHeight}px`;
      });
      // setTimeout(, 1);
    };

    const textareas = document.querySelectorAll('textarea');
    if (textareas && textareas.length) {
      textareas.forEach((textarea) => {
        textarea.classList.add('stage');
        const mirrow = document.createElement('textarea');
        mirrow.classList.add('mirrow');
        mirrow.cols = 80;
        mirrow.rows = 1;
        textarea.closest('.text-container').appendChild(mirrow);
        textarea.addEventListener('keydown', textareaAutosize);
        textarea.addEventListener('keyup', textareaAutosize);
      });
    }
  }, 5);
});



// WEBPACK FOOTER //
// ./src/materials/atoms/form/form.js